import React, { useState } from 'react';
import { Text, Flex, Stack, Image } from '@tapresearch/ui/components';

import { LegendSvgProps } from '@nivo/legends';
import { BarDatum } from '@nivo/bar';
import { useCustomBarLegend } from './useCustomBarLegend';
import { TapAnswer } from '../../../../api';
import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';
import { AnimatePresence } from 'framer-motion';

export interface ImageChoiceLegendsProps {
  data: BarDatum[];
  answersById: Record<string, TapAnswer['attributes']>;
  hiddenSeries?: string[];
  layerProps?: Omit<LegendSvgProps, 'data'>;
  layerData?: LegendSvgProps['data'];
  toggleSerie?: (serieId: string) => void;
}

export function ImageChoiceLegends({
  data,
  answersById,
  layerData,
  hiddenSeries = [],
  toggleSerie = () => {
    //
  },
}: ImageChoiceLegendsProps) {
  const legendsData = useCustomBarLegend({
    data,
    layerData,
    hiddenSeries,
    answersById,
  });

  return data ? (
    <Stack>
      {legendsData.map((legendData, index) => (
        <ImageChoiceLegend
          key={`legend-${index}`}
          onClick={() => toggleSerie(legendData.id)}
          borderColor={legendData.color}
          imageUrl={answersById[legendData.id].image.url}
          textColor={legendData.textColor}
          label={legendData.label}
        />
      ))}
    </Stack>
  ) : null;
}

interface ImageChoiceLegendProps {
  onClick: () => void;
  borderColor: string;
  imageUrl: string;
  textColor: string;
  label: string;
}

function ImageChoiceLegend({
  onClick,
  borderColor,
  imageUrl,
  textColor,
  label,
}: ImageChoiceLegendProps) {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <Flex
      alignItems="center"
      w="228px"
      cursor="pointer"
      _hover={{ fontWeight: 'bold' }}
      onClick={onClick}
      border="1px solid"
      borderColor={borderColor}
      paddingX="2"
      paddingY="1"
      borderRadius="md"
      position="relative"
    >
      <Image
        width="6"
        src={imageUrl}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      />

      <AnimatePresence>
        {isHovering && (
          <OpacityTransitionBox
            bottom="36px"
            left="8px"
            h="180px"
            w="180px"
            bgColor="white"
            position="absolute"
            duration={1}
            zIndex={1}
          >
            <Image w="100%" src={imageUrl} alt={label} />
          </OpacityTransitionBox>
        )}
      </AnimatePresence>

      <Text fontSize="sm" ml="2" textColor={textColor}>
        {label}
      </Text>
    </Flex>
  );
}
